import Decimal from 'decimal.js';
import type { Receivable } from '../api/useDebts';

export interface DebtGroup {
  contactId: string;
  currencyId: string;
  total: Decimal;
  oldestCreatedAt: string;
  rows: Receivable[];
}

export function groupDebts(rows: Receivable[]): DebtGroup[] {
  const groups = new Map<string, DebtGroup>();
  for (const row of rows) {
    const key = `${row.contactId}:${row.currencyId}`;
    let group = groups.get(key);
    if (!group) {
      group = {
        contactId: row.contactId,
        currencyId: row.currencyId,
        total: new Decimal(0),
        oldestCreatedAt: row.createdAt,
        rows: [],
      };
      groups.set(key, group);
    }
    group.total = group.total.plus(row.outstandingAmount);
    group.rows.push(row);
    if (row.createdAt < group.oldestCreatedAt) group.oldestCreatedAt = row.createdAt;
  }
  for (const group of groups.values()) {
    group.rows.sort((a, b) => a.createdAt.localeCompare(b.createdAt));
  }
  return [...groups.values()].sort(
    (a, b) =>
      a.oldestCreatedAt.localeCompare(b.oldestCreatedAt) ||
      a.contactId.localeCompare(b.contactId) ||
      a.currencyId.localeCompare(b.currencyId),
  );
}

export function totalsByCurrency(rows: Receivable[]): Map<string, Decimal> {
  const totals = new Map<string, Decimal>();
  for (const row of rows) {
    totals.set(
      row.currencyId,
      (totals.get(row.currencyId) ?? new Decimal(0)).plus(row.outstandingAmount),
    );
  }
  return totals;
}
